import { Props_SnippetQuickLinks } from "./QuickLinks.props"

const SnippetQuickLinks = (props: Props_SnippetQuickLinks) => {
    const { heading, repeatable_entry } = props
    const classHeadingVisibility: string = heading.visibility.value ? `snippet-quick-links__heading--${heading.visibility.value}` : ''

    return (
    <section className="snippet-quick-links">
        <div className={`snippet-quick-links__container`}>
            <h2 className={`snippet-quick-links__heading ${classHeadingVisibility}`}>{heading.content.value}</h2>
            <div className="snippet-quick-links__container-entries">
                { repeatable_entry.map((entry, index: number) => (
                    <div key={index} className={`snippet-quick-links__entry`}>
                        { entry.linkContent?.value && entry.linkUrl?.value && entry.linkTarget?.value && (
                            <a
                                href={entry.linkUrl.value}
                                className="snippet-quick-links__entry-link"
                                target={entry.linkTarget.value === 'true' ? '_blank' : '_self'}
                                rel={entry.linkTarget?.value === 'true' ? 'noopener noreferrer' : undefined}
                            >
                                {entry.linkContent.value}
                            </a>
                        )}
                    </div>
                ))}
            </div>
        </div>
    </section>
    )
}

export default SnippetQuickLinks
